<!-- NEWS AND TENDERS - STARTS -->
<section class="news-section">
    <div class="container-xxl">
        <div class="row" data-aos="fade-up" data-aos-duration="600" data-aos-once="true">
            <div class="col-lg-6 mb-5 mb-lg-0">
                <div class="me-lg-0 me-xl-4">
                    <ul class="nav nav-pills mb-4" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active screen-reader" [attr.title]="language=='English'?'News':'समाचार'" id="news" data-bs-toggle="pill" data-bs-target="#news-tab"
                                type="button" role="tab" aria-controls="pills-home" aria-selected="true">{{ 'News' | translate }}</button>
                        </li> 
                        <li class="nav-item" role="presentation">
                            <button class="nav-link screen-reader" [attr.title]="language=='English'?'Press Release':'प्रेस विज्ञप्ति'" (click)="getPressReleaseList()" id="press-relese-tab" data-bs-toggle="pill"
                                data-bs-target="#press-relese" type="button" role="tab" aria-controls="press-relese"
                                aria-selected="false">{{ 'PressRelease' | translate }}</button>
                        </li> 

                        <li class="nav-item" role="presentation">
                            <button class="nav-link screen-reader" [attr.title]="language=='English'?'Awards':'पुरस्कार'" (click)="getAwardsList()" id="awards-tab" data-bs-toggle="pill" data-bs-target="#awards"
                                type="button" role="tab" aria-controls="awards" aria-selected="false">{{ 'Awards' | translate }}</button>
                        </li>

                    </ul>
                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active" id="news-tab" role="tabpanel" aria-labelledby="news"
                            tabindex="0">
                            <div class="info-box font-adjust">
                                <div class="d-flex gap-2 info-item pb-3 position-relative mb-3"
                                    *ngFor="let item of newsList ; let i = index" [attr.data-index]="i+1">
                                    <div class="info-detail-box d-flex flex-column pe-2">
                                        <a class="screen-reader" (click)="viewDetails(item.id, 'news')" *ngIf="language=='English'">{{htmldecode(item.title)}}</a>
                                        <a class="screen-reader" (click)="viewDetails(item.id, 'news')" *ngIf="language=='Hindi'">{{htmldecode(item.titleInHindi)}}</a>

                                        <div class="text-grey mt-2">
                                            <span class="me-2"><i class="icon-fci-calendar"></i></span>
                                            <span class="info-date screen-reader">{{item.publishDate | date}}</span>
                                        </div>
                                    </div>
                                    <div class="info-image-box" *ngIf="item.uploadImage !=''">
                                        <img alt="FCI - image" [src]="this.imageUrl+item.uploadImage">
                                    </div>
                                </div>
                            </div>
                            <div class="float-end me-4 mt-4">
                                <a *ngIf="newsLength > 0" (click)="viewMore('newslist')" [attr.title]="language=='English'?'Click to view more':'अधिक देखने के लिए क्लिक करें'" class="btn btn-orange-outline screen-reader">{{ 'ViewMore' | translate}}</a>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="press-relese" role="tabpanel" aria-labelledby="press-relese-tab"
                            tabindex="0">
                            <div class="info-box font-adjust">
                                <div class="d-flex info-item pb-3 gap-3 mb-3" *ngFor="let item of pressReleaseList">
                                    <div class="info-icon-box">
                                        <a href="javascript:void(0);" title="Download PDF" target="_blank">
                                            <i class="icon-fci-icon-press"></i>
                                        </a>
                                    </div>
                                    <div class="d-flex flex-column justify-content-center me-2">
                                        <a class="screen-reader" (click)="viewDetails(item.id, 'pressreleasedetails')" *ngIf="language=='English'">{{htmldecode(item.title)}}</a>
                                        <a class="screen-reader" (click)="viewDetails(item.id, 'pressreleasedetails')" *ngIf="language=='Hindi'">{{htmldecode(item.titleInHindi)}}</a>
                                        <div class="text-grey mt-2">
                                            <span class="me-2"><i class="icon-fci-calendar"></i></span> <span
                                                class="info-date screen-reader">{{item.publishDate | date: 'MMM d, y'}}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="float-end me-4 mt-4">
                                <a *ngIf="pressReleaseLength > 0" (click)="viewMore('pressrelease')" [attr.title]="language=='English'?'Click to view more':'अधिक देखने के लिए क्लिक करें'" class="btn btn-orange-outline screen-reader">{{ 'ViewMore' | translate}}</a>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="awards" role="tabpanel" aria-labelledby="awards-tab"
                            tabindex="0">
                            <div class="info-box font-adjust">
                                <div class="d-flex gap-2 info-item pb-3 position-relative mb-3" *ngFor="let item of awardsList">
                                    <div class="info-detail-box d-flex flex-column">
                                        <a class="screen-reader" (click)="viewDetails(item.id, 'awarddetails')" *ngIf="language=='English'">{{htmldecode(item.title)}}</a>
                                        <a class="screen-reader" (click)="viewDetails(item.id, 'awarddetails')" *ngIf="language=='Hindi'">{{htmldecode(item.titleInHindi)}}</a>
                                        <div class="mt-2">
                                            <ul class="text-grey report-details">
                                                <li class="screen-reader">{{'Date' | translate}}: {{ item.fromDate|date}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="info-image-box">
                                        <img [src]="this.imageUrl+item.featuredImage" alt="Award-image">
                                    </div>
                                </div>
                            </div>
                            <div class="float-end me-4 mt-4" >
                                <a *ngIf="awardsListLength > 0" (click)="viewMore('award')" [attr.title]="language=='English'?'Click to view more':'अधिक देखने के लिए क्लिक करें'" class="btn btn-orange-outline screen-reader">{{ 'ViewMore' | translate}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="me-lg-0 me-xl-0">
                    <ul class="nav nav-pills mb-4" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active screen-reader" [attr.title]="language=='English'?'Tenders':'निविदाएं'" id="tender" data-bs-toggle="pill"
                                data-bs-target="#tender-tab" type="button" role="tab" aria-controls="pills-tender"
                                aria-selected="true">{{ 'Tenders' | translate }}</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link screen-reader" [attr.title]="language=='English'?'Circulars':'परिपत्र'" (click)="getCircularList()" id="circular" data-bs-toggle="pill" data-bs-target="#circular-tab"
                                type="button" role="tab" aria-controls="pills-circular"
                                aria-selected="false">{{ 'Circulars' | translate }}</button>
                        </li>
                        <!-- <li class="nav-item" role="presentation">
                            <button class="nav-link screen-reader" [attr.title]="language=='English'?'Recruitment':'भर्ती'" (click)="Recruitment()" id="recruitment" data-bs-toggle="pill"
                                data-bs-target="#recruitment-tab" type="button" role="tab"
                                aria-controls="pills-recruitment" aria-selected="false">{{ 'Recruitment' | translate }}</button>
                        </li> -->
                    </ul>
                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active" id="tender-tab" role="tabpanel" aria-labelledby="tender"
                            tabindex="0">
                            <div class="info-box font-adjust">

                                <div class="d-flex gap-3 mb-3 info-item" *ngFor="let item_ of tenderList;">


                                    <div class="info-icon-box">
                                            <i class="icon-fci-icon-tender"></i>
                                    </div>
                                    <div>
                                        <a class="screen-reader" href="javascript:void(0);" (click)="viewTenderDetails(item_.id,'tender-details')" *ngIf="language=='English'">{{ htmlTag(item_.title)}}</a>
                                        <a class="screen-reader" href="javascript:void(0);" (click)="viewTenderDetails(item_.id,'tender-details')" *ngIf="language=='Hindi'">{{ htmlTag(item_.titleInHindi)}}</a>

                                        <div class="mt-2">
                                            <ul class="text-grey report-details">
                                                <!-- 07 Jul 2023 -->
                                                <li class="screen-reader">{{'PublishDate' | translate}}: {{ item_.publishDate | date: 'MMM d, y'}}</li>
                                                <li class="screen-reader">{{'ID' | translate}}: {{htmlTag(item_.tenderNumber)}}</li>
                                                <!-- <li>Zone: {{ jsonConvert(item_,'ZONE_ID')}}, Region: {{
                                                    jsonConvert(item_,'REGION_ID')}}</li> -->
                                            </ul>
                                        </div>
                                    </div>


                                </div>

                            </div>
                            <div class="float-end me-4 mt-4">
                                <a *ngIf="tenderLength > 0" (click)="viewMore('tender')" [attr.title]="language=='English'?'Click to view more':'अधिक देखने के लिए क्लिक करें'" class="btn btn-orange-outline screen-reader">{{ 'ViewMore' | translate}}</a>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="circular-tab" role="tabpanel" aria-labelledby="circular"
                            tabindex="0">
                            <div class="info-box font-adjust">
                                <div class="d-flex gap-3 mb-3 info-item" *ngFor="let item of circularList">
                                    <div class="info-icon-box" *ngIf="item.uploadDocument==''">
                                        <a href="javascript:void(0)" title="{{ htmlTag(item.title) }}">
                                            <i class="icon-fci-icon-circular"></i>
                                        </a>
                                    </div>
                                    <div class="info-icon-box" *ngIf="item.uploadDocument!==''">
                                        <a [href]="backend_url+'storage/app/uploads/'+item.uploadDocument"
                                            [download]="item.uploadDocument" title="{{ htmlTag(item.title)}}"
                                            target="_blank">
                                            <i class="icon-fci-icon-circular"></i>
                                        </a>
                                    </div>
                                    <div>
                                        <a class="screen-reader" (click)="viewDetails(item.id, 'circulardetails')"
                                        title="View Details" title="{{ htmlTag(item.title) }}" *ngIf="language=='English'">{{htmldecode(item.title)}}</a>
                                        <a class="screen-reader" (click)="viewDetails(item.id, 'circulardetails')"
                                        title="View Details" title="{{ htmlTag(item.title) }}" *ngIf="language=='Hindi'">{{htmldecode(item.titleInHindi)}}</a>

                                        <div class="mt-2">
                                            <ul class="text-grey report-details">
                                                <li class="screen-reader" *ngIf="item.division != ''">{{'Division' | translate}}: {{ getDivisionName(item) }} </li>
                                                <li class="screen-reader">{{'DateOfIssue' | translate}}: {{ item.publishDate|date}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div> 
                            <div class="float-end me-4 mt-4">
                                <a *ngIf="circularLength > 0" (click)="viewMore('circular')" [attr.title]="language=='English'?'Click to view more':'अधिक देखने के लिए क्लिक करें'" class="btn btn-orange-outline screen-reader">{{ 'ViewMore' | translate}}</a>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="recruitment-tab" role="tabpanel" aria-labelledby="recruitment"
                            tabindex="0">
                            <div class="info-box font-adjust">

                                <div class="custom-border-width d-flex gap-3 mb-3" *ngFor="let r of current_data;">

                                    <div class="info-icon-box">
                                            <i class="icon-fci-icon-recruitment"></i>
                                       
                                    </div>

                                    <div class="info-recruitment-box d-flex flex-column justify-content-center me-2">
                                        <a class="screen-reader" (click)='goToExtLink(r.redirectURL)' href="javascript:void(0)"
                                            title="{{ htmlTag(r.title) }}"  *ngIf="language=='English'">{{ htmlTag(r.title) }}</a>

                                            <a class="screen-reader" (click)='goToExtLink(r.redirectURL)' href="javascript:void(0)"
                                            title="{{ htmlTag(r.title) }}"  *ngIf="language=='Hindi'">{{ htmlTag(r.titleInHindi) }}</a>
                                        <div
                                            class="text-grey mt-1 mb-2 d-lg-flex d-md-flex d-flex justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <h5><span class="badge bg-green screen-reader">{{ jsonConvert(r,'CATEGORY') }}</span></h5>
                                            </div>
                                            <span class="d-flex align-items-center pe-2">
                                                
                                                    <span class="ms-2">
                                                        <i class="icon-fci-calendar me-2"></i>
                                                        <span class="info-date me-2 screen-reader">{{ r.publishDate | date: 'MMM d, y'
                                                            }}</span>
                                                    </span>

                                                <span class="ms-2" *ngIf="CheckFile(r.document_details)">
                                            <a [href]="backend_url+'storage/app/uploads/'+r.document"
                                            [download]="r.document" title="{{ htmlTag(r.title)}}" target="_blank" *ngIf="r.document!==''">

                                            <span class="info-date">
                                                <i class="bi bi-download me-2"> </i>
                                                <span class="download-text screen-reader">Download</span>
                                            </span>
                                                            </a>
                                                </span>

                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="float-end me-4 mt-4">
                                <a *ngIf="RecruitmentLength > 0" (click)="viewMore('recruitment')" [attr.title]="language=='English'?'Click to view more':'अधिक देखने के लिए क्लिक करें'" class="btn btn-orange-outline screen-reader">{{ 'ViewMore' | translate}}</a>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- NEWS AND TENDERS - ENDS -->